module.exports = __webpack_public_path__ + "static/media/dropdownIcon2.e4075656.svg";